import {ReactComponent as HubEsfIcon} from './hubEsf.svg'

function HubEsf() {
  return <HubEsfIcon />
}

export default HubEsf
